/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetWebimVisitorResponse } from '../../entities/v1/GetWebimVisitorResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1WebimFieldsModelSchema } from './webimFieldsModelSchema'
import { z } from 'zod'

export const v1GetWebimVisitorResponseSchema = z.object({
  fields: z.lazy(() => v1WebimFieldsModelSchema),
  hash: z.string(),
}) as unknown as ToZod<V1GetWebimVisitorResponse>